import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Route, Routes } from "react-router-dom";
import { UserContextProvider } from "./components/functional";
import { PageLayout } from "./components/layout/PageLayout";
import { useZendeskClassicWebWidget } from "./hooks/useZendeskClassicWebWidget";
import { Administration, Login } from "./pages";
import AgreementApprovalPage from "./pages/AgreementApprovalPage";
import { AnalyticsDashboard, QuotesDashboard } from "./pages/dashboard";
import {
  AccumulatorWorkflow,
  DealEntryWorkflow,
  InsuranceWizard,
  NewQuote,
  QuoteDetails,
  VanillaWorkflow,
} from "./pages/quotes";
import { Profile } from "./pages/user/Profile";

const Pages = () => {
  useZendeskClassicWebWidget();

  return (
    <Routes>
      <Route path="/" element={<QuotesDashboard />} />
      <Route path="/analytics" element={<AnalyticsDashboard />} />
      <Route path="/quote">
        <Route path="new" element={<NewQuote />} />
        <Route path="dealcapture" element={<DealEntryWorkflow />} />
        <Route path="insurance/:step?" element={<InsuranceWizard />} />
        <Route path="/quote/details/:quoteId" element={<QuoteDetails />} />
        <Route path="vanilla/:step?" element={<VanillaWorkflow />} />
        <Route path="accumulator/:step?" element={<AccumulatorWorkflow />} />
      </Route>
      <Route path="/admin/:tab?/:itemId?" element={<Administration />} />
      <Route path="/user/profile" element={<Profile />} />
      <Route path="agreements" element={<AgreementApprovalPage />} />
    </Routes>
  );
};

const App = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <UserContextProvider>
          <PageLayout>
            <Pages />
          </PageLayout>
        </UserContextProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default App;
